import React, {} from 'react';
import * as _ from 'lodash';
import Downshift from 'downshift';

export default function Tyre(props) {
  const tyre = props.tyre;
  const config = props.config;
  const onChange = props.onChange;

  const dropdownItems = _.map(config.makes, (label, id) => ({ id, value: label }));
  return (<fieldset className="styled-fieldset">
    <legend>{props.legend}</legend>
    <div>
      <label>
        <span>Lokalizacja</span>
        <select name="location" onChange={e => onChange(e.currentTarget.value, 'location')}>
          {_.map(config.locations, (name, id) => <option
            selected={('location' in tyre ? tyre.location : null) === id}
            key={`location-${id}`}
            value={id}>{name}</option>)}
        </select>
      </label>
    </div>
    <div>
      <label>
        <span>Rodzaj</span>
        <select name="type" onChange={e => onChange(e.currentTarget.value, 'type')}>
          {_.map(config.types, (name, id) => <option selected={(tyre.type !== undefined ? tyre.type : null) === id}
                                                     key={`type-${id}`}
                                                     value={id}>{name}</option>)}
        </select>
      </label>
    </div>
    <Downshift
      selectedItem={(tyre.make !== undefined ? tyre.make : null)}
      onStateChange={
        (changes) => {
          if (changes.hasOwnProperty('selectedItem')) {
            return onChange(changes.selectedItem.value, 'make')
          } else if (changes.hasOwnProperty('inputValue')) {
            return onChange(changes.inputValue, 'make')
          }
        }
      }
      itemToString={item => {
        return (item ? (undefined !== item.value ? item.value : item) : '');
      }}
      // initialInputValue={(tyre.make !== undefined ? tyre.make : null)}
    >
      {({
          getInputProps,
          getItemProps,
          getLabelProps,
          getMenuProps,
          isOpen,
          inputValue,
          highlightedIndex,
          selectedItem,
          getRootProps,
        }) => <div style={{ position: 'relative' }}>
        <label  {...getLabelProps()}>
          <span>Marka</span>
          <input type="text" {...getInputProps()} />
        </label>
        {isOpen
          ? <div className="autocomplete-menu" {...getMenuProps()}>
            <ul>{
              dropdownItems
                .filter(item => !inputValue || item.value.toLowerCase().includes(inputValue.toLowerCase()))
                .map((item, index) => (
                  <li
                    {...getItemProps({
                      key: item.id,
                      index,
                      item,
                      style: {
                        backgroundColor:
                          highlightedIndex === index ? 'lightgray' : 'white',
                        fontWeight: selectedItem === item ? 'bold' : 'normal',
                      },
                    })}
                  >
                    {item.value}
                  </li>
                ))
            } </ul>
          </div>
          : null}
      </div>}
    </Downshift>
    <div>
      <label>
        <span>Model</span>
        <input name="model" type="text" value={(tyre.model !== undefined ? tyre.model : null)}
               onChange={e => onChange(e.currentTarget.value, 'model')} />
      </label>
    </div>
    <div>
      <label>
        <span>Rozmiar (w formacie: 000/00R00)</span>
        <input name="size" type="text" value={(tyre.size !== undefined ? tyre.size : null)}
               onChange={e => {
                 let val = e.currentTarget.value;
                 val = val.replace(',', '.');
                 if (val.match(/^[0-9]{3}$/)) {
                   val = (val + '/');
                 } else if (val.match(/^\d{3}\/\d{2}$/)) {
                   val = (val + 'R');
                 }
                 onChange(val, 'size')
               }} />
      </label>
    </div>
    <div>
      <label>
        <span>Głębokość bieżnika</span>
        <input name="depth" type="number" value={(tyre.depth !== undefined ? tyre.depth : null)}
               onChange={e => onChange(e.currentTarget.value, 'depth')} />
      </label>
    </div>
    <div>
      <label>
        <span>Kołpak</span>
        <select name="cap" onChange={e => onChange(e.currentTarget.value, 'cap')}>
          {_.map({ 0: 'Nie', 1: 'Tak' }, (name, id) => <option
            selected={(tyre.cap !== undefined ? tyre.cap : 0) === id} key={`cap-${id}`}
            value={id}>{name}</option>)}
        </select>
      </label>
    </div>
  </fieldset>);
}
